export default function restrictBodyScroll(restrict:boolean): void {
	if (restrict) {		
		document.body.classList.add('v2-overflow-hidden');
	} else {
		document.body.classList.remove('v2-overflow-hidden');
	}
}
